import {
  LOCATION_CHANGE,
} from 'actions/actionTypes';
import { getUrlParams } from 'utilities/getUrlParams';
import { get } from 'lodash';

const redirect = () => next => (action) => {
  const { type } = action;
  switch (type) {
    case LOCATION_CHANGE: {
      const query = get(action, 'payload.location.search');
      if (!query) return next(action);
      const queryVars = getUrlParams(query);
      const { path } = queryVars;
      if (!path) return next(action);
      const history = get(action, 'payload.history');
      history.push(path);
      return null;
    }


    default:
      next(action);
      return null;
  }
};

export default redirect;
